// extracted by mini-css-extract-plugin
export var actionIcon = "_rj-0";